module.exports = __webpack_public_path__ + "img/horizontal_7_2_2.09e7cfa1.png";